import { ProductSupplierOrderChannel } from '@gooduncles/gu-app-schema';
import { FC } from 'react';

import { PurchaseOrderWithProductSupplier } from 'src/utils/supplier-purchase-order-util';

import PrintWindow from 'src/components/PrintWindow/PrintWindow';

import classes from './SupplierPurchaseOrderPrint.module.scss';

interface SupplierPurchaseOrderPrintProps {
  rowData: PurchaseOrderWithProductSupplier[];
  selectedChannels: ProductSupplierOrderChannel[];
}

const SupplierPurchaseOrderPrint: FC<SupplierPurchaseOrderPrintProps> = ({ rowData, selectedChannels }) => {
  const data = rowData
    .filter((r) => r.productSupplier?.orderChannel && selectedChannels.includes(r.productSupplier.orderChannel))
    .sort((a, b) => a.productSupplier?.name.localeCompare(b.productSupplier?.name ?? '') ?? 0);
  return (
    <PrintWindow>
      <div className={classes.purchaseOrderPrintList}>
        <div className={classes.header}>
          <p>거래처</p>
          <p>내용</p>
        </div>
        {data.map((row) => (
          <div key={row._id} className={classes.purchaseOrderItem}>
            <p>{row.productSupplier?.name}</p>
            <p className={classes.orderMessage}>{row.messageBody}</p>
          </div>
        ))}
      </div>
    </PrintWindow>
  );
};

export default SupplierPurchaseOrderPrint;
